import { SET_ACCOUNTS } from "./types";

const setAccounts = (accounts) => async (dispatch) => {
    dispatch({ type: SET_ACCOUNTS, accounts });
};

export default setAccounts;
